import React from 'react';
import { ASSET_PREFIX } from 'utils/constants';
import SectionTitle from 'components/landing/StrongerVariant/SectionTitle/SectionTitle';
import svStyles from 'components/landing/StrongerVariant/StrongerVariant.module.css';
import s from './FreemiumSoClosePopup.module.css';
import Router from 'next/router';
import RoundedButton from 'components/RoundedButton';
import ContentCarousel from 'components/landing/ContentCarousel/ContentCarousel';

const FreemiumSoClosePopup = ({ prize, onClose }) => {

  const StandardTextComponent = ({ prizeName, includeLite = false }) => (
    <p className={s.mainText}>
      If you were a <strong>Premium</strong> {includeLite && <>or <strong>Lite</strong></>} member,
      you would've won a <strong>{prizeName}</strong> like these!
    </p>
  );

  const getPrizeDetails = () => {
    switch (prize.prizeCode) {
      case 'TH_TOKEN':
        return {
          textComponent: (
            <p className={s.mainText}>
              If you were a <strong>Premium</strong> member, you would've won a <strong>DAYMADE token</strong> which you can collect & exchange for free entries, prizes and more!
            </p>
          ),
          images: [
            {
              src: `${ASSET_PREFIX}/images/reveal/3-token-stack-square.png`,
            },
          ],
        };

      case 'TH_TOKEN_X2':
        return {
          textComponent: (
            <p className={s.mainText}>
              If you were a <strong>Premium</strong> member, you would've won <strong>2 DAYMADE tokens</strong> which you can collect & exchange for free entries, prizes and more!
            </p>
          ),
          images: [
            {
              src: `${ASSET_PREFIX}/images/reveal/3-token-stack-square.png`,
            },
          ],
        };

      case 'PRIZE_5':
        return {
          textComponent: <StandardTextComponent prizeName={prize.prizeName} />,
          images: [
            {
              src: `${ASSET_PREFIX}/images/prizes/5/authentic-house/main.jpg`,
              caption: 'Authentic House Gift Card',
            },
            {
              src: `${ASSET_PREFIX}/images/prizes/5/indytute-gift-card/main.jpg`,
              caption: 'Indytute Gift Card',
            },
            {
              src: `${ASSET_PREFIX}/images/prizes/5/th-tokens/main.jpg`,
              caption: '10 DAYMADE Tokens',
            },
          ],
        };

      case 'PRIZE_10':
        return {
          textComponent: <StandardTextComponent prizeName={prize.prizeName} />,
          images: [
            {
              src: `${ASSET_PREFIX}/images/prizes/10/sourdough-starter-kit/main.jpg`,
              caption: 'Sourdough Starter Kit',
            },
            {
              src: `${ASSET_PREFIX}/images/prizes/10/sock-sloth-craft-kit/main.jpg`,
              caption: 'Sock Sloth Craft Kit',
            },
            {
              src: `${ASSET_PREFIX}/images/prizes/10/snag-tights/main.jpg`,
              caption: 'Snag Tights Gift Card',
            },
          ],
        };

      case 'LOCALITE':
      case 'PRIZE_BRONZE':
        return {
          textComponent: <StandardTextComponent prizeName={prize.prizeName} />,
          images: [
            {
              src: `${ASSET_PREFIX}/images/prizes/localite/chillys-bottle/main.jpg`,
              caption: 'Personalised Chilly\'s Bottle',
            },
            {
              src: `${ASSET_PREFIX}/images/prizes/localite/audible/main.jpg`,
              caption: '3 Month Audible Subscription',
            },
            {
              src: `${ASSET_PREFIX}/images/prizes/localite/spa-at-home/main.jpg`,
              caption: 'Rituals Gift Box',
            },
          ],
        };

      case 'WEEKENDER':
      case 'PRIZE_SILVER':
        return {
          textComponent: <StandardTextComponent prizeName={prize.prizeName} />,
          images: [
            {
              src: 'https://prize-assets.daymade.co.uk/0837f51a-b0d6-45da-a936-94695dcd9114.jpg',
              caption: 'Pig Hotel & restaurant',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/9acebdc1-216c-4da8-bf82-6c0ef7e71412.jpg',
              caption: 'Woman with alpaca',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/6a4ad03b-4192-44c8-875f-d012ef87a62e.jpg',
              caption: 'Thermae Bath Spa',
            },
          ],
        };

      case 'PRIZE_500':
      case 'PRIZE_GOLD':
        return {
          textComponent: <StandardTextComponent prizeName={prize.prizeName} />,
          images: [
            {
              src: 'https://prize-assets.daymade.co.uk/a6c56c8d-6b9a-4c4a-8d49-92cdb3efb6f4.jpg',
              caption: 'Yoga in Devon',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/ee986600-b675-4bd3-9591-5a8584f8f4c9.jpg',
              caption: 'De’Longhi Dedica Barista coffee machine',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/f6025ebb-7924-4218-a37d-36c498d6ecc2.jpg',
              caption: 'Nintendo Switch OLED',
            },
          ],
        };

      case 'GLOBETROTTER':
      case 'PRIZE_PLATINUM':
        return {
          textComponent: <StandardTextComponent prizeName={prize.prizeName} />,
          images: [
            {
              src: 'https://prize-assets.daymade.co.uk/e9b356c0-1053-4175-827a-2ffd05744c42.jpg',
              caption: 'Trip to Barbados',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/4316dd00-c6ee-49b0-9fd1-762c0af9b2e2.jpg',
              caption: 'Home Decor, Furniture & Accessories',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/49a4f1a6-ad01-4be4-95a3-4423f1c1e23e.jpg',
              caption: 'Ultimate Arctic Circle adventure in Norway',
            },
          ],
        };

      case 'PRIZE_10000':
      case 'PRIZE_DIAMOND':
        return {
          textComponent: <StandardTextComponent prizeName={prize.prizeName} />,
          images: [
            {
              src: 'https://prize-assets.daymade.co.uk/3a35695d-0b56-4fe2-a985-e503f8f260f0.jpg',
              caption: 'Trip to the Maldives',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/2596dbcf-6fa0-4eb7-8cc8-61d7f704c007.jpg',
              caption: 'Chef 10,000 Package',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/06b2e836-0b31-4ea1-aeef-8fabd7edb215.jpg',
              caption: 'MADE.com £10k home make-over',
            },
          ],
        };

      case 'BUCKETLISTER':
      case 'PRIZE_DAYMAKER':
        return {
          textComponent: <StandardTextComponent prizeName={prize.prizeName} />,
          images: [
            {
              src: 'https://prize-assets.daymade.co.uk/cc590301-2f5a-4ed4-8673-42b6a6b88660.jpg',
              caption: 'Trip to Japan',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/5bcc7941-06aa-4c5c-8a60-5c539fc0d75a.jpg',
              caption: 'Trip to New Zealand',
            },
            {
              src: 'https://prize-assets.daymade.co.uk/06b2e836-0b31-4ea1-aeef-8fabd7edb215.jpg',
              caption: 'MADE.com £25k home make-over',
            },
          ],
        };

      default:
        return {
          textComponent: <StandardTextComponent prizeName={prize.prizeName} />,
        };
    }
  };

  const prizeDetails = getPrizeDetails();

  return (
    <div className={s.container} id="dimmedBackground" onClick={(e) => e.target.id === 'dimmedBackground' && onClose()}>
      <div id={s.message}>
        <SectionTitle>
          <div className={`${svStyles.underline} ${s.heading}`}>So</div>
          <div className={`${svStyles.underline} ${svStyles.outlineText} ${s.heading}`}>close!</div>
        </SectionTitle>

        { prizeDetails.textComponent }

        { prizeDetails.images && prizeDetails.images.length === 1 && (
          <div className={s.prizeImages}>
            <div className={s.prizeImage} style={{ backgroundImage: `url(${prizeDetails.images[0].src})` }} />
            { prizeDetails.images[0].caption && (
              <p className={s.prizeImageCaption}>{prizeDetails.images[0].caption}</p>
            )}
          </div>
        )}

        { prizeDetails.images && prizeDetails.images.length > 1 && (
          <ContentCarousel
            darkOnLight
            scrollUsingDots
            showInstagramLink={false}
            showAllOnDesktop={false}
            containerClassName={s.prizeImages}
            contentCarouselClassName={s.contentCarousel}
            pageIndicatorContainerClassName={s.contentCarouselDots}
          >
            { prizeDetails.images.map((prizeImage, i) => (
              <div key={i} style={{ position: 'relative', width: '100%', flexShrink: 0 }}>
                <div className={s.prizeImage} style={{ backgroundImage: `url(${prizeImage.src})`, backgroundSize: 'cover', backgroundPosition: '50% 50%' }} />
                { prizeImage.caption && (
                  <p className={s.prizeImageCaption}>{prizeImage.caption}</p>
                )}
              </div>
            ))}
          </ContentCarousel>
        )}

        <RoundedButton onClick={() => Router.push('/account/subscriptions/upgrade')} style={{ fontSize: '1.1em', marginTop: '1.5em', width: '70%' }}>
          Upgrade now
        </RoundedButton>

        <p className={s.maybeLater} onClick={onClose}>
          I'll upgrade later
        </p>
      </div>
    </div>
  );
};

export default FreemiumSoClosePopup;
